export default __webpack_public_path__ + "static/media/showroom46.add77dbd.jpg";